import { BusinessOperatingSystem } from '../company/business-operating-system.enum';
import { MazStatus } from '../maz/maz-status.enum';
import { PartnerType } from '../partner-hub/partner-type.enum';

import { PersonMetadata } from './person-metadata';

export interface Person {
  _id: string;
  personId?: string;
  metadata?: PersonMetadata;
  personMetadataId?: string;
  primaryEmail?: string;
  primaryPhoneNumber?: string;
  consentToContactByPhone?: boolean;
  deleted?: boolean;
  __v?: number;
  isImplementer?: boolean;
  /**
   * @deprecated Legacy classification (Partner Stack era). Superseded by the
   * partner-signup data stamped on the Person via the new partner-signup flow
   * (`partnerSignup.partnerType`, a `PartnerSignupType`). Delete once existing
   * partners have been migrated.
   */
  partnerType?: PartnerType;
  /**
   * @deprecated Replaced by `partnerSignup.coachingSystem`. Delete once existing
   * partners have been migrated.
   */
  bosTypes?: BusinessOperatingSystem[];
  partner_key?: string;
  partner_email?: string;
  hasCreatedCompany?: boolean;
  defaultCustomizationsId?: string;
  referralLinks?: { url: string }[];
  helpfulPermissions?: HelpfulPermissions;
  mazDismissClickTimes?: number[];
  /** Person has opted in or out of MAZ chat */
  mazStatus?: MazStatus;
  legals?: {
    privacyPolicy?: Date;
  };
  notificationBackoff?: NotificationBackoff;
  referAFriendLink?: string;
}

export interface NotificationBackoff {
  dismissCount?: number;
  dismissedAt?: number | null;
  /** When true, the user has exhausted all prompts and will never be prompted again.
   *  The only way to re-enable notifications is manually through browser/OS settings. */
  promptingDisabled?: boolean;
}

export class HelpfulPermissions {
  adjustPricing? = false;
  companies? = false;
  coupons? = false;
  dataUpload? = false;
  emailSuppressionList? = false;
  hardDeleteCompany? = false;
  manageHelpfuls? = false;
  manualCharge? = false;
  users? = false;

  /** allows user to apply template to any company they are in along with their referred companies */
  applyTemplates?: boolean;

  /** prevents a partner stack customer from being created when a company is created */
  doNotCreatePartnerStackCustomer?: boolean;

  /** Partners Management Page */
  partners? = false;
  partnersAdmin = false; // ability to update/delete partners/customers

  /** Partner Hub */
  domoAdmin? = false; // allows user to view a specific coach's Domo embed dashboard

  /** Allows user to add/create/update default learn modules */
  learnModuleAdmin?: boolean; // allows user to view learning modules

  /** allows user to update the assigned rock quarters for all of a company's rocks */
  updateRockQuarters?: boolean = false;

  constructor(permissions: HelpfulPermissions) {
    Object.assign(this, permissions);
  }
}
